export enum NotificationType {
  Task = 1,
  Appointment = 2,
  RemindersRefreshed = 3,
  SignableDocument = 4,
  MaintenanceRequest = 5,
}
